import CardWrapper from "../../components/wrapper/card/CardWrapper";
import AppCSSService from "../../services/AppCSSService";
import { IDeviceStateControllerReturn } from "../../../../../commonreact/main/services/devicestate/DeviceStateController";
import { images } from "../../../../../Media";
import { IModalVideoControllerReturn } from "../../../../../commonreact/main/components/modals/modalvideo/ModalVideoController";
import { ELng } from "../../../../../language/main/LanguageKeysEnums";
import { useTranslation } from "react-i18next";
import CommonReactGUIElementsFactory from "../../../../../commonreact/main/factorys/guielements/CommonReactGUIElementsFactory";
import { AndroidAppPromoCard } from "./uimodels/cards/AndroidAppPromoCard";
import { AndroidAppVideoGalleryCard } from "./uimodels/cards/AndroidAppVideoGalleryCard";
import { AndroidAppImageGalleryCard } from "./uimodels/cards/AndroidAppImageGalleryCard";

interface IProps {
  dsc: IDeviceStateControllerReturn;
  mvc: IModalVideoControllerReturn;
}

const AndroidApp = (props: IProps) => {

  const tag = "AndroidApp";
  console.log(tag + "START")

  //const { t } = useTranslation();
  const ef = CommonReactGUIElementsFactory.getFactory({})

  return (
    // <div className={`${AppCSSService.cardsWrapper} ${!props.dsc.small ? "w-4/5" : "w-full"} mt-4`}>
    <div className={`${AppCSSService.cardsWrapper} ${(!props.dsc.small && !props.dsc.isMobile) ? "w-4/5" : "w-full"} mt-4`}>

      <AndroidAppPromoCard dsc={props.dsc} ef={ef}/>

      <AndroidAppImageGalleryCard dsc={props.dsc} ef={ef} mvc={props.mvc}/>

      <AndroidAppVideoGalleryCard dsc={props.dsc} ef={ef} mvc={props.mvc}/>

      {/* <CardWrapper
        dsc={props.dsc}
        header={<div className="flex flex-row items-center">
        <img className={"w-[2.5rem]"} src={images.logoFree} />
          <h3 className="ml-2" >Free Version</h3>
        </div>}
      >
        <div className="flex flex-row">
          <div className="w-full">
            <h2> {t(ELng.android_app_freeversion_desc0.valueOf())} </h2>
            <h2> {t(ELng.android_app_freeversion_desc1.valueOf())} </h2>

            <p>Rock - dorian I IV</p>
            <p>Rock - lydian I II</p>
            <p>Rock - mixolydian I II</p>
            <p>Jazz - ionian II V I</p>
            <p>Jazz - aeolain II V I</p>
          </div>
        </div>
      </CardWrapper> */}
    </div>);
}


export default AndroidApp;